export default "__VITE_ASSET__Cj2Juo2B__"